<template>
    <v-btn
        :block="orientation === 'column'"
        outlined
        class="text-none mx-auto pr-2"
        :class="[
            orientation === 'column' ? 'mb-4' : null,
            fullWidthFormat ? 'pr-4' : null,
            image ? 'btn-image pl-8' : null
        ]"
        :color="isSelected ? 'green darken-2' : '#DADADA'"
        @click.stop="selectValue(value)"
    >
        <v-row
            no-gutters
            dense
            align="center"
        >
            <v-col
                :cols="image ? 8 : 12"
                class="my-auto"
                :class="{
                    'text-left': image,
                    'text-center': !image
                }"
            >
                <v-card
                    flat
                    tile
                    color="transparent"
                    max-width="230px"
                >
                    <span
                        :class="[isSelected ? 'green-darken-2--text' : 'black--text']"
                        class="h4"
                    >
                        {{ label }}
                    </span>
                    <div
                        v-if="sublabel"
                        class="sublabel"
                    >
                        <label class="grey-text">
                            {{ sublabel }}
                        </label>
                    </div>
                    <div
                        v-if="fullWidthFormat"
                        class="sublabel"
                    >
                        <label class="grey-text">
                            {{ $t('habiteoStudio.ratio') + " " + ratio }}
                        </label>
                    </div>
                </v-card>
            </v-col>
            <v-col
                v-if="image && !imageOnLeft"
                cols="4"
                class="text-right"
            >
                <div class="d-flex justify-end">
                    <v-img
                        :src="image"
                        contain
                        :aspect-ratio="fullWidthFormat ? 2.0 : 1.5"
                    />
                    <v-icon 
                        v-if="helpImage" 
                        class="mb-10" 
                        right 
                        color="black"
                        @click="toggleHelpPopUp"
                    >
                        mdi-help-circle-outline
                    </v-icon>
                    <HelpPopUp 
                        v-if="helpImage" 
                        :showPopUp="showHelpPopUp" 
                        :helpImage="helpImage"
                        :showTwobyTwo="showTwobyTwo"
                        @toggle-pop-up="toggleHelpPopUp"
                    />
                </div>
            </v-col>
        </v-row>
    </v-btn>
</template>

<script>
    import HelpPopUp from '@/components/myHabiteoStudio/steps/components/HelpPopUp';
    export default {
        name: 'StepBtn',
        components: {
            HelpPopUp 
        },
        data() {
            return {
                showHelpPopUp: false
            };
        },
        props: {
            image: {
                type: String,
                required: false
            },
            label: {
                type: String,
                required: true
            },
            sublabel: {
                type: String,
                required: false
            },
            orientation: {
                type: String,
                required: false
            },
            isSelected: {
                type: Boolean,
                required: false
            },
            value: {
                type: [Number, Boolean],
                required: true
            },
            imageOnLeft: {
                type: Boolean,
                required: false
            },
            layout: {
                type: String,
                required: false
            },
            fullWidthFormat: {
                type: Boolean,
                required: false
            },
            ratio: {
                type: String,
                required: false
            },
            helpImage: {
                type: Array,
                required: false
            },
            showTwobyTwo: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        methods: {
            selectValue(val) {
                this.$emit('select-value', val);
            },
            toggleHelpPopUp() {
                this.showHelpPopUp = !this.showHelpPopUp;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/components/StepBtn.vue